/**
 * @module portal\table
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhBase from "@/components/ghBase";
import GhClassService from "@/utils/mixins/clsService";
import { MethodService } from "@/utils/serviceModel";
import { Watch } from "vue-property-decorator";
import GhTablePage from "@/components/ghTablePage/ghTablePage";

@Component
export default class Table extends GhClassService {
  protected module = "plat.db";
  protected cls = "DataTablesService";
  protected serviceMethods: { [key: string]: MethodService | null } = {
    getDbs: null
  };
  private args = { db: "portal", keyword: "" };

  private templateModel = { Db: "portal" };

  @Watch("args.db")
  private query() {
    this.templateModel.Db = this.args.db;
    let page = this.$refs.table as GhTablePage;
    page.query();
  }

  private configColumn(item) {
    this.navigate("column", { tableId: item.Id });
  }

  mounted() {
    if (this.serviceMethods.getDbs) {
      this.serviceMethods.getDbs.invokeAsyn();
    }
  }
}
